// extracted by mini-css-extract-plugin
export default {"mainContainer":"Layout_mainContainer__ghiwr"};